import { registerAction } from '../../Action'

const SET_WEEK_VIEW_START_DAY = 'SET_WEEK_VIEW_START_DAY'

const reducer = (state = {}, action) => ({
  ...state,
  weekViewStartDay: action.payload,
})

const setWeekViewStartDay = registerAction(SET_WEEK_VIEW_START_DAY, { reducer })

export default setWeekViewStartDay
